import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import JsonData from "../data/data.json";

const REGISTER_URL = `https://app.${JsonData?.Header?.nameBankDomain || "micbank"}.com.br/register`;

const SLIDER_SETTINGS = {
  dots: true,
  infinite: true,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 8000,
  arrows: true,
  adaptiveHeight: false,
  centerMode: false,
  variableWidth: false,
  pauseOnHover: true,
};

/* Posters = 1º frame do próprio MP4 (public/img/video-posters/*.jpg) para não haver “outra imagem” antes do vídeo carregar.
 * Ao trocar um .mp4, regenere o JPG: ffmpeg -y -i public/video/NOME.mp4 -ss 0 -vframes 1 -q:v 2 public/img/video-posters/NOME.jpg */
const POSTER_V = "1";
const posterFor = (name) => `/img/video-posters/${name}.jpg?v=${POSTER_V}`;

const SLIDES = [
  {
    type: "video",
    video: "/video/agro-wheat-fields.mp4",
    poster: posterFor("agro-wheat-fields"),
    title: "Mic Bank",
    protectedText: "Soluções Financeiras para seu negócio",
    subtitle:
      "Crédito, pagamentos e gestão para o agronegócio, médias empresas e grandes corporações em todo o Brasil.",
  },
  {
    type: "video",
    video: "/video/agro-towers-motion.mp4",
    poster: posterFor("agro-towers-motion"),
    title: "Da cidade ao agro",
    protectedText: "Soluções para grandes operações",
    subtitle:
      "Conectamos empresas urbanas e o agronegócio com soluções financeiras para grandes operações e cadeias produtivas.",
  },
  {
    type: "video",
    video: "/video/agro-field-motion.mp4",
    poster: posterFor("agro-field-motion"),
    title: "Do campo",
    protectedText: "para o seu fluxo de caixa",
    subtitle:
      "Antecipação, boletos, PIX e gestão financeira para produtores, indústrias e grandes negócios.",
  },
  {
    type: "image",
    image: "/img/agro-farm.webp",
    title: "Do agro ao seu negócio",
    protectedText: "Da cidade ao agro",
    subtitle:
      "Atendemos o agronegócio, médias empresas e grandes corporações com soluções financeiras de ponta a ponta.",
  },
  {
    type: "video",
    video: "/video/agro-soy-motion.mp4",
    poster: posterFor("agro-soy-motion"),
    title: "Safra & produção",
    protectedText: "finanças no mesmo ritmo",
    subtitle: `Na ${JsonData?.About?.nameBank || "Mic Bank"} você integra operações do campo e da cidade e acompanha tudo em um só lugar.`,
  },
  {
    type: "video",
    video: "/video/agro-farm-motion.mp4",
    poster: posterFor("agro-farm-motion"),
    title: "Cresça com",
    protectedText: "quem investe no agro",
    subtitle:
      "Tecnologia, proximidade e atendimento dedicado para produtores, empresas e grandes corporações.",
  },
];

const openInNewTab = () => {
  window.open(REGISTER_URL, "_blank", "noreferrer");
};

const SlideMedia = ({ slide, isActive }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const el = videoRef.current;
    if (!el || slide.type !== "video") return;
    if (isActive) {
      el.play().catch(() => {});
    } else {
      el.pause();
    }
  }, [isActive, slide.type]);

  if (slide.type === "video") {
    return (
      <video
        ref={videoRef}
        className="slide-video"
        src={slide.video}
        poster={slide.poster}
        muted
        loop
        playsInline
        preload={isActive ? "auto" : "metadata"}
        aria-label={slide.title}
      />
    );
  }

  return (
    <img
      src={slide.image}
      alt={slide.title}
      loading="lazy"
      className="slide-img"
    />
  );
};

const SlideItem = ({ slide, isActive }) => (
  <div className="slide-wrapper">
    <div className="slide-image">
      <SlideMedia slide={slide} isActive={isActive} />
      <div className="overlay">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 intro-text intro-text--hero">
              <h1 className="upp">{slide.title}</h1>
              {slide.protectedText && (
                <p className="protected-text">{slide.protectedText}</p>
              )}
              <p className="subtitle">{slide.subtitle}</p>
              <button type="button" className="btn btn-custom btn-lg" onClick={openInNewTab}>
                Abra sua conta
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export const Slidershow = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  if (SLIDES.length === 1) {
    return (
      <div className="slideshow slideshow--hero-top">
        <SlideItem slide={SLIDES[0]} isActive />
      </div>
    );
  }

  return (
    <div className="slideshow slideshow--hero-top">
      <Slider {...SLIDER_SETTINGS} afterChange={(i) => setCurrentSlide(i)}>
        {SLIDES.map((slide, index) => (
          <SlideItem
            key={slide.video || slide.image || index}
            slide={slide}
            isActive={currentSlide === index}
          />
        ))}
      </Slider>
    </div>
  );
};
